import React from 'react';
import type { FC } from 'react';
import type { CustomMenuItemProps } from '@ag-grid-community/react';
import { useGridMenuItem } from '@ag-grid-community/react';

export const DataGridContextMenuItem: FC<CustomMenuItemProps> = ({
  name,
  subMenu,
  menuItemParams,
}) => {
  useGridMenuItem({
    configureDefaults: () => true,
  });

  return (
    <div data-test={menuItemParams.testId}>
      <span className="ag-menu-option-part ag-menu-option-text">{name}</span>
      {!!subMenu && (
        <span
          data-test={`${menuItemParams.testId}_SUB_MENU_POINTER`}
          className="ag-menu-option-part ag-menu-option-popup-pointer"
        >
          <span className="ag-icon ag-icon-small-right" role="presentation" />
        </span>
      )}
    </div>
  );
};
